import React from 'react';
import PropTypes from 'prop-types';
import { AutoparksTransportsContainer } from '../../../autoparks-transports';
import { AutoparkForm } from '../autopark-form';

export const AutoparkModalContent = ({ isAutoparkFormOpen }) => {
	return isAutoparkFormOpen ? <AutoparkForm /> : <AutoparksTransportsContainer />;
};

AutoparkModalContent.propTypes = {
	autoparkInfo: PropTypes.object,
	isAutoparkInfoLoading: PropTypes.bool.isRequired,
	isAutoparkFormOpen: PropTypes.bool.isRequired,
};
